import { FelaCSS } from '../../components/fela/flowtypes';
import { IStylingProps } from '../../themes/types';
import IconWrap from './icon-wrap';

interface IProps extends IStylingProps {
  id?: string;
  color?: string;
  width?: number;
  style?: FelaCSS;
}

interface IconTypes {
  iconColor: string;
  width: number;
  height: number;
}

const IconChecklist = ({ id, color, width = 50, style, ...restProps }: IProps) => {
  const viewBoxWidth = 50;
  const viewBoxHeight = 40;

  const icon = ({ width, height }: IconTypes) => (
    <svg
      id={id}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      width={`${width}px`}
      height={`${height}px`}>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Icons-HUB" transform="translate(-766.000000, -160.000000)">
          <g transform="translate(766.000000, 160.000000)">
            <path
              d="M3.61408424,35.9243996 L36.0431548,35.9243996 L36.0431548,3.54769772 L3.61408424,3.54769772 L3.61408424,35.9243996 Z M37.7798062,39.392011 L1.87743284,39.392011 C0.918029422,39.392011 0.140781439,38.615266 0.140781439,37.6582053 L0.140781439,1.81466262 C0.140781439,0.856831305 0.918029422,0.0808569419 1.87743284,0.0808569419 L37.7798062,0.0808569419 C38.7392096,0.0808569419 39.5164576,0.856831305 39.5164576,1.81466262 L39.5164576,37.6582053 C39.5164576,38.615266 38.7392096,39.392011 37.7798062,39.392011 L37.7798062,39.392011 Z"
              fill={color}
            />
            <path
              d="M22.8471512,29.6033294 C21.9402332,29.6033294 21.0425774,29.20571 20.4335917,28.4451472 L11.3088393,17.0459528 C10.2436931,15.7167018 10.4605815,13.7771512 11.7927861,12.7137504 C13.123447,11.6518907 15.0669529,11.8676532 16.1320991,13.1976748 L23.3758651,22.2458287 L44.3584732,6.31562216 C45.7153769,5.28381513 47.652708,5.54812418 48.6846648,6.90357493 C49.7166217,8.25825509 49.4534225,10.1924116 48.095747,11.2219069 L24.7142444,28.9745359 C24.1562004,29.3975845 23.4993603,29.6033294 22.8471512,29.6033294"
              fill={color}
            />
          </g>
        </g>
      </g>
    </svg>
  );

  return (
    <IconWrap
      icon={icon}
      color={color}
      width={width}
      viewBoxWidth={viewBoxWidth}
      viewBoxHeight={viewBoxHeight}
      style={style}
      {...restProps}
    />
  );
};

export default IconChecklist;
